import { render, staticRenderFns } from "./indicator-description.vue?vue&type=template&id=311a1a85&scoped=true&"
import script from "./indicator-description.vue?vue&type=script&lang=js&"
export * from "./indicator-description.vue?vue&type=script&lang=js&"
import style0 from "./indicator-description.vue?vue&type=style&index=0&id=311a1a85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a1a85",
  null
  
)

export default component.exports